﻿import { SoapChronologyState, PatientRecordsSearchFilterFields, ColumnOptions, GridConfiguration, PatientRecordsSearchGridData } from './soap-chronology.model';

export const SEARCH_SOAP_CHRONOLOGY_RECORDS = 'SEARCH_SOAP_CHRONOLOGY_RECORDS'; 
export const GET_SOAP_CHRONOLOGY_RECORDS = 'GET_SOAP_CHRONOLOGY_RECORDS';
export const RESET_SOAP_CHRONOLOGY_GRID_DATA = 'RESET_SOAP_CHRONOLOGY_GRID_DATA';
export const RESET_SOAP_CHRONOLOGY_RECORDS_TO_INITIAL_STATE = 'RESET_SOAP_CHRONOLOGY_RECORDS_TO_INITIAL_STATE';

export const emptyString: string = "";
const patientRecordsSearchFilterFields: PatientRecordsSearchFilterFields = {
    lastName: emptyString,
    firstName: emptyString,
    dob: emptyString,
};

const columnOptions: ColumnOptions[] = [
    { header: 'Last Name', field: 'Last_Name', sortable: true },
    { header: 'First Name', field: 'First_Name', sortable: true },
    { header: 'Date of Birth', field: 'DOB', sortable: true }
];

export const gridConfiguration: GridConfiguration = {
    page: 1,
    pageSize: 5,
    sort: "Last_Name",
    order: 1
};
const patientRecordsSearchGridData: PatientRecordsSearchGridData = {
    rows: 5,
    rowsPerPageOptions: [5, 10, 20],
    cols: columnOptions,
    pageLinks: 3,
    configuration: gridConfiguration,
    filterData: [],
    totalRecords: 0
};

export const initialState: SoapChronologyState = {
    patientRecordsSearchFilterFields: patientRecordsSearchFilterFields,
    patientRecordsSearchGridData: patientRecordsSearchGridData
};